export enum AllotmentsIds {
  NOOCO = 1,
  RE2020 = 2,
  EPCM = 34,
}

export enum AllotmentsKeys {
  RE2020 = "Re2020AllotmentNodeId",
  EPCM = "EpcmAllotmentNodeId",
}
